// extracted by mini-css-extract-plugin
export var benefitsWrapper = "Benefits-module--benefits-wrapper--vOFh7";
export var benefitsItem = "Benefits-module--benefits-item--2Bnl4";